import { ProductPriceRangeFragment } from '@graphql/fragments/__generated__/ProductPriceRange.generated'
import { ProductVariantPriceRangeFragment } from '@graphql/fragments/__generated__/ProductVariantPriceRange.generated'
import React from 'react'
import { showPrice } from '../../../misc/price'

interface IProps {
  priceRange: ProductVariantPriceRangeFragment | ProductPriceRangeFragment
  qty: number
}

const FavoritesLinePrice: React.FC<IProps> = ({ qty, priceRange }) => {
  const isPriceRange = priceRange.discount.max !== priceRange.discount.min
  const isSale =
    priceRange.discount.max !== priceRange.undiscount.max ||
    priceRange.discount.min !== priceRange.undiscount.min
  return (
    <>
      {isPriceRange ? (
        <span>
          <span className={isSale ? 'line-through' : ''}>
            {showPrice({
              amount: priceRange.undiscount.min * qty,
              currency: priceRange.currency,
            })}
          </span>

          <span> - </span>
          <span className={isSale ? 'line-through' : ''}>
            {showPrice({
              amount: priceRange.undiscount.max * qty,
              currency: priceRange.currency,
            })}
          </span>
        </span>
      ) : (
        <span className={isSale ? 'line-through' : ''}>
          {showPrice({
            amount: priceRange.undiscount.min * qty,
            currency: priceRange.currency,
          })}
        </span>
      )}
      {isSale &&
        (isPriceRange ? (
          <span className='text-red'>
            <span>
              {showPrice({
                amount: priceRange.discount.min * qty,
                currency: priceRange.currency,
              })}
            </span>

            <span> - </span>
            <span>
              {showPrice({
                amount: priceRange.discount.max * qty,
                currency: priceRange.currency,
              })}
            </span>
          </span>
        ) : (
          <span className='text-red'>
            {' '}
            {showPrice({
              amount: priceRange.discount.min * qty,
              currency: priceRange.currency,
            })}
          </span>
        ))}
    </>
  )
}

export default FavoritesLinePrice
